import gql from 'graphql-tag'
import {GraphqlUpdater} from '@/scripts/utils'
import {AccessTokenUpdater, fetchUserQueries} from '@/scripts/auth-utils'
import {store, eventBus} from '@/scripts/globals'

export default {
    data: function () {
        return {
            store,
            graphqlUpdater: new GraphqlUpdater(
                {
                    targetObjIdsGetter: this.idsGetter,
                    fetchQuery: gql(fetchUserQueries.fetchQuery),
                    fetchUpdateQuery: gql(fetchUserQueries.fetchQuery),
                    updatedDataSetter: this.updatedDataSetter,
                    autoUpdatePeriodMs: 3000,
                    name: 'Auth'
                }),
            accessTokenUpdater: new AccessTokenUpdater()
        }
    },
    methods: {
        updatedDataSetter(oRes) {
            let vals = Object.values(oRes)
            if (vals.length)
                this.store.myUser = vals[0]

        },
        idsGetter() {
            if (this.store.myUser)
                return [this.store.myUser.id]
            else
                return []
        }
    },
    async beforeDestroy() {
        // noinspection JSUnresolvedVariable
        await this.graphqlUpdater.stop()
        // noinspection JSUnresolvedVariable
        await this.accessTokenUpdater.stop()
    },
    async created() {
        // noinspection JSUnresolvedVariable
        await this.accessTokenUpdater.start()
        let fetchedObjects = {}
        fetchedObjects[this.store.myUser.id] = this.store.myUser
        // noinspection JSUnresolvedVariable
        await this.graphqlUpdater.start(false, fetchedObjects, this.store.myUser.updatedAt)
        // noinspection JSUnresolvedVariable
        if (this.onCreated) { // noinspection JSUnresolvedFunction
            await this.onCreated()
        }
        eventBus.$on('forceUpdateUserProfile', async () => {
            await this.graphqlUpdater.forceRun()
        })
    }
}